export default "__VITE_ASSET__jN_WfZoQmDYs3ly$nssacQ__"